import { CloseOutlined } from '@ant-design/icons';

import * as St from './SelectedFilter.styles';

type SelectedFilterProps = {
  filterName: string;
  onRemove?: () => void;
};

const SelectedFilter = ({ filterName, onRemove }: SelectedFilterProps) => (
  <St.Container>
    {filterName}
    {onRemove && (
      <St.CloseButton onClick={onRemove}>
        <CloseOutlined />
      </St.CloseButton>
    )}
  </St.Container>
);

export default SelectedFilter;
